interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-lg'
          : 'bg-white/90 backdrop-blur-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/481dad7d-79fb-4494-a936-587c106954e4.png" 
              alt="Climatizzatori 24h Logo" 
              className="w-12 h-12 object-contain"
            />
            <span className="text-[#1A2B4A] font-bold text-lg whitespace-nowrap">Climatizzatori 24h</span>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-[#1A2B4A] text-sm font-medium hover:text-[#00A3E0] transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              Servizi
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00A3E0] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-[#1A2B4A] text-sm font-medium hover:text-[#00A3E0] transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              Chi Siamo
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[#1A2B4A] text-sm font-medium hover:text-[#00A3E0] transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              Contatti
            </button>
          </div>

          {/* CTA */}
          <div className="flex items-center gap-4">
            <a
              href="tel:+393806328251"
              className="hidden lg:flex items-center gap-2 text-[#1A2B4A] font-medium text-sm whitespace-nowrap"
            >
              <i className="ri-phone-fill text-[#00A3E0]"></i>
              +39 380 632 8251
            </a>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#1A2B4A] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#2C4A7C] transition-all duration-300 flex items-center gap-2 cursor-pointer whitespace-nowrap"
            >
              Preventivo Gratuito
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}